import * as React from "react";
import { observer } from "mobx-react";
import { WBSStore } from "modules/WBS/WBSStore";
import { ProjectStore } from "modules/project/ProjectStore";
import { CostPlanStore } from "modules/costPlan/CostPlanStore";
import { MonetizationOn, MoreHoriz } from "@material-ui/icons";
import { Typography, withStyles, Menu, MenuItem } from "@material-ui/core";
import i18n from "i18n";
import { Cube } from "common/icons";
import * as _ from "lodash";
import { Render3dStore } from "modules/render3D/Render3dStore";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { IsolateArray } from "modules/render3D/models/IsolateArray";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import {
  exportAnalyticalCurveABCReport,
  exportAnalyticalEAPReport,
  exportResourceReport,
  exportSyntheticCurveABCReport,
  exportSyntheticEAPReport,
} from "../../assets/excelReports/export";
import { default as firebase } from "common/Firebase";
import { CSVLink } from "react-csv";
import { WBSModels } from "modules/WBS/WBSModels";
import { CustomPropertyStore } from "modules/customProperties/CustomPropertyStore";
import { EReportType, ERowType, EWBSView } from "common/enums";

const ABC_COLOR = [
  { pMin: 0, pMax: 80, c: "ffff4500", toolbar: "Curva A - De 0% a 80%" },
  { pMin: 80, pMax: 95, c: "ffff8c00", toolbar: "Curva B - De 80,01% a 95%" },
  { pMin: 95, pMax: 101, c: "ffc0d147", toolbar: "Curva C - De 95,01% a 100%" },
];

const styles = (theme) => ({
  topBar: {
    backgroundColor: "#ABC200",
    height: "30px",
    display: "flex",
    alignItems: "center",
    padding: "0px 10px",
    cursor: "pointer",
    transition: "all 0.3s ease-in",
    "&:hover": {
      backgroundColor: "#ABC200",
      "& > span": {
        color: "#FFFFFF",
      },
      "& > svg": {
        color: "#FFFFFF",
      },
    },
  },
  menu: {
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingLeft: "8px",
    paddingRight: "8px",
    fontStyle: "normal",
    // fontWeight: "400 !important",
    fontSize: "14px !important",
    lineHeight: "20px",
  },
  monetization: {
    fontSize: "15px",
    marginRight: "8px",
    color: "#FFFFFF",
    transition: "all 0.3s ease-in",
  },
  cube: {
    fontSize: "15px",
    marginRight: "8px",
    color: "#ABC200",
  },
  topBarText: {
    fontFamily: "Raleway",
    fontSize: "10px",
    fontWeight: 700,
    color: "#FFFFFF",
    textTransform: "uppercase" as any,
    transition: "all 0.3s ease-in",
  },
  more: {
    color: "#FFFFFF",
    fontSize: "22px",
    marginLeft: "auto",
  },

  topBarUnselected: {
    backgroundColor: "#474747",
    height: "30px",
    display: "flex",
    alignItems: "center",
    padding: "0px 10px",
    cursor: "pointer",
    transition: "all 0.3s ease-in",
    "&:hover": {
      backgroundColor: "#ABC200",
      "& > span": {
        color: "#FFFFFF",
      },
      "& > svg": {
        color: "#FFFFFF",
      },
    },
  },
  divider: {
    marginTop: "16px",
    marginBottom: "6px",
    marginLeft: "8px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "10px",
    lineHeight: "12px",
    color: "#BDBDBD",
  },
  dividerFirst: {
    marginTop: "8px",
    marginBottom: "6px",
    marginLeft: "8px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "10px",
    lineHeight: "12px",
    color: "#BDBDBD",
    "&:focus": {
      outline: "none",
      // box-shadow: 0px 0px 2px red;
    },
  },
  monetizationUnselected: {
    fontSize: "15px",
    marginRight: "8px",
    color: "#ABC200",
    transition: "all 0.3s ease-in",
  },
  topBarTextUnselected: {
    fontFamily: "Raleway",
    fontSize: "10px",
    fontWeight: 700,
    color: "#ABC200",
    textTransform: "uppercase" as any,
    transition: "all 0.3s ease-in",
  },
  moreUnselected: {
    color: "#bcbcbc",
    fontSize: "22px",
    marginLeft: "auto",
  },
  progress: {
    margin: 0,
    color: "#ABC200",
    zIndex: 2,
    position: "absolute" as any,
    right: "12px" as any,
    width: "26px !important",
    height: "26px !important",
  },
  downloadUnselected: {
    color: "#bcbcbc",
    fontSize: "22px",
    marginLeft: "auto",
  },
  download: {
    color: "#FFFFFF",
    fontSize: "22px",
    marginLeft: "auto",
  },
});

type IProps = {
  name: string;
  classes: any;
  development: any;
  developmentName: string;
};

@observer
class Header extends React.Component<IProps> {
  state = {
    anchorEl: null,
    multiDataSet: [],
    arrReponse: [],
    csvData: [],
  };

  handleClickOptCard = (event) => {
    this.setState({ anchorEl: event.currentTarget });
    this.killEvent(event);
  };

  handleCloseOptCard = (event) => {
    this.setState({ anchorEl: null });
    this.killEvent(event);
  };

  killEvent = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  handleExportResourcesFile = (event) => {
    let columnsStyle: any = {
      font: { bold: true },
    };

    let columns: any = [
      {
        title: i18n.project.rightSideMenu.code,
        width: { wpx: 90 },
        style: {
          alignment: { horizontal: "center" },
          ...columnsStyle,
        },
      }, //pixels width
      {
        title: i18n.resources.description,
        width: { wpx: 220 },
        style: {
          font: { bold: true },
          ...columnsStyle,
        },
      },
      {
        title: i18n.resources.quantity,
        width: { wpx: 94 },
        style: {
          alignment: { horizontal: "center" },
          ...columnsStyle,
        },
      },
      {
        title: i18n.resources.unit,
        width: { wpx: 70 },
        style: {
          alignment: { horizontal: "center" },
          ...columnsStyle,
        },
      },
      {
        title: i18n.resources.unitCost,
        width: { wpx: 100 },
        style: {
          alignment: { horizontal: "center" },
          ...columnsStyle,
        },
      },
      {
        title: i18n.resources.total,
        width: { wpx: 100 },
        style: {
          alignment: { horizontal: "center" },
          ...columnsStyle,
        },
      },
      {
        title: i18n.resources.classification,
        width: { wpx: 95 },
        style: {
          alignment: { horizontal: "center" },
          ...columnsStyle,
        },
      },
      {
        title: i18n.resources.origin,
        width: { wpx: 80 },
        style: {
          alignment: { horizontal: "center" },
          ...columnsStyle,
        },
      },
      {
        title: i18n.resources.percentage,
        width: { wpx: 90 },
        style: {
          alignment: { horizontal: "center" },
          ...columnsStyle,
        },
      },
      {
        title: i18n.resources.cumulativePercentage,
        width: { wpx: 170 },
        style: {
          alignment: { horizontal: "center" },
          ...columnsStyle,
        },
      },
    ];
    let rows: any = [];
    let rowsStyle: any = {
      font: { sz: "10", name: "Calibri" },
    };

    WBSStore.resourcesDataTable.forEach((e) => {
      let color = "ff00ff00";
      let tmpColor = ABC_COLOR.filter(
        (abc) =>
          e.cumulative_percentage > abc.pMin &&
          e.cumulative_percentage <= abc.pMax
      )[0];
      if (tmpColor != undefined) {
        color = tmpColor.c;
      }

      rows.push([
        { value: e.code ? e.code : "", style: { ...rowsStyle } },
        { value: e.description ? e.description : "", style: { ...rowsStyle } },
        { value: e.quantity ? e.quantity : 0, style: { ...rowsStyle } },
        {
          value: e.unit ? e.unit : "",
          style: { ...rowsStyle, alignment: { horizontal: "center" } },
        },
        {
          value: e.unitCost ? e.unitCost : 0,
          style: { ...rowsStyle, numFmt: "R$ #,##0.00" },
        },
        {
          value: e.total_cost ? e.total_cost : 0,
          style: { ...rowsStyle, numFmt: "R$ #,##0.00" },
        },
        { value: e.category ? e.category : "", style: { ...rowsStyle } },
        { value: e.origin ? e.origin : "", style: { ...rowsStyle } },
        {
          value: e.percentage ? e.percentage / 100 : 0,
          style: { ...rowsStyle, numFmt: "0.00%" },
        },
        {
          value: e.cumulative_percentage ? e.cumulative_percentage / 100 : 0,
          style: {
            fill: {
              patternType: "solid",
              ...rowsStyle,
              fgColor: { rgb: color },
            },
            numFmt: "0.00%",
          },
        },
      ]);
    });
    this.setState(
      {
        multiDataSet: [{ columns: columns, data: rows }],
      },
      () => {
        let excel_data = document.getElementById("excel_id");
        if (excel_data) {
          excel_data.click(); // Click on the checkbox
        }
      }
    );
    this.setState({ anchorEl: null });
    this.killEvent(event);
  };

  handleExportFile = (event) => {
    let wbsRowsCount = WBSStore.WBSRows.length;
    if (wbsRowsCount === 0) {
      ProjectStore.showSnackMessage(i18n.wbs.noRowsToExport);
    } else {
      CostPlanStore.addCostPlanExport();
      CostPlanStore.layerAdd = true;
    }
    this.setState({ anchorEl: null });
    this.killEvent(event);
  };

  getInformationWBS = firebase.functions().httpsCallable("exportSapSheet");

  public exportSAPSheet = async (development) => {
    WBSStore.loading = true;
    let arrWBS = await this.exportSapSheetCallable(development);

    let dataExportSheet = new Array();
    arrWBS.forEach((value) => {
      dataExportSheet.push([
        value.sheetDiagram,
        value.sheetTask,
        value.sheetElement,
        value.code,
        value.descResource,
        value.sheetMat.toString().replace(/\./g, ","),
        value.sheetMO.toString().replace(/\./g, ","),
        value.sheetMO2.toString().replace(/\./g, ","),
      ]);
    });

    let data = [
      [
        "Diagrama",
        "Tarefa",
        "Elemento",
        "Código",
        "Desc. Insumo",
        "Material",
        "M.O",
        "M.O.2",
      ],
      ...dataExportSheet,
    ];

    this.setState({
      csvData: data,
    });

    WBSStore.loading = false;
    return data;
  };

  async exportSapSheetCallable(development: any): Promise<any> {
    // const firebase = admin;
    const firestore = firebase.firestore();
    let response: any;
    let stageId: any;
    let taskId: any;
    let arrWbs = new Array();
    let arrResources = new Array();
    let sheetDiagram: any;
    let sheetTask: any;
    let sheetElement: any;
    let sheetMat: any;
    let sheetMO: any;
    let sheetMO2: any;
    let descResource: any;
    let code: any;
    let quantity: any;
    let cost: any;
    let stageRow: any;
    let rowWbs: object;
    let hasResource: boolean;

    response = development;

    const wbsDevelopment = await firestore
      .collection("wbsProjectBudget")
      .where("development", "==", response)
      .get();

    const wbsId = wbsDevelopment.docs[0].id;

    const row = await firestore
      .collection("wbsProjectBudget")
      .doc(wbsId)
      .collection("rows")
      .get();

    const rows = row.docs.map((doc: any) => {
      return WBSModels.wbsRows(doc);
    });

    let diagramSheetObj = await CustomPropertyStore.getWBSCustomPropertyByLabel(
      "Diagrama"
    );
    let taskSheetObj = await CustomPropertyStore.getWBSCustomPropertyByLabel(
      "Tarefa"
    );

    if (diagramSheetObj == undefined || taskSheetObj == undefined) {
      return;
    }

    let diagramSheetId = diagramSheetObj.id;
    let taskSheetId = taskSheetObj.id;

    rows.forEach((stage) => {
      if (
        stage.data.rowType == 0 &&
        stage.data.customProperties !== undefined
      ) {
        let diagramCode = stage.data.customProperties[diagramSheetId];
        let taskCode = stage.data.customProperties[taskSheetId];

        stageId = stage.id;

        let arrStage = new Array();

        rows.forEach((task) => {
          if (task.data.rowType == 1 && task.data.parentStage == stageId) {
            taskId = task.id;

            rows.forEach((resource) => {
              if (
                resource.data.parentTask == taskId &&
                resource.data.rowType == 2
              ) {
                hasResource = false;
                quantity = WBSStore.getResourceQuantity(
                  resource,
                  diagramSheetId,
                  taskSheetId,
                  diagramCode,
                  taskCode
                );

                arrStage = arrStage.map((item) => {
                  if (
                    resource.data &&
                    resource.data.description == item.descResource
                  ) {
                    hasResource = true;
                    item.quantity = this.strip(item.quantity + quantity);
                    let resultData = this.updateRowsByCode(
                      resource.data.rowCode ? resource.data.rowCode : "",
                      item.quantity,
                      item.cost
                    );
                    item.sheetMat = resultData.sheetMat;
                    item.sheetMO = resultData.sheetMO;
                    item.sheetMO2 = resultData.sheetMO2;
                  }
                  return item;
                });

                if (hasResource == false) {
                  descResource = resource.data.description;
                  code = resource.data.rowCode;
                  quantity = this.strip(quantity);
                  cost = resource.data.unitCost;
                  sheetDiagram = diagramCode;
                  sheetTask = taskCode;
                  stageRow = taskId;
                  let resultData = this.updateRowsByCode(code, quantity, cost);
                  sheetMat = resultData.sheetMat;
                  sheetMO = resultData.sheetMO;
                  sheetMO2 = resultData.sheetMO2;

                  rowWbs = {
                    sheetDiagram,
                    sheetTask,
                    sheetElement,
                    sheetMat,
                    sheetMO,
                    sheetMO2,
                    quantity,
                    descResource,
                    code,
                    cost,
                    stageRow,
                  };

                  arrStage.push(rowWbs);
                }
              }
            });
          }
        });

        arrWbs = arrWbs.concat(arrStage);
      }
    });

    return arrWbs;
  }
  strip(number) {
    return Number(parseFloat(number).toPrecision(12));
  }
  updateRowsByCode(code: string, quantity, cost) {
    let sheetMat, sheetMO, sheetMO2;

    let codeSubstring: any = 0;
    if (code) {
      codeSubstring = Number(code.substring(0, 4));
      codeSubstring = isNaN(codeSubstring)
        ? code.substring(0, 5).toUpperCase()
        : codeSubstring;
    }
    /*
    Coluna Material 
      Quando o código do insumo começar com 1000~1999 - Preencher com a quantidade
      Quando o código do insumo começar com 3000~3999 - Vazia
      Quando o código do insumo começar com 9000~9999 - Vazia
      Quando o código do insumo for VERBA - Vazia
    */
    if (
      (codeSubstring >= 3000 && codeSubstring <= 3999) ||
      codeSubstring === "VERBA"
    ) {
      sheetMat = "";
    } else if (codeSubstring >= 9000 && codeSubstring <= 9999) {
      sheetMat = "";
    } else {
      sheetMat = quantity;
    }
    /*
    Coluna M.O 
      Quando o código do insumo começar com 1000~1999 - Vazia
      Quando o código do insumo começar com 3000~3999 - Preencher com quantidade
      Quando o código do insumo começar com 9000~9999 - Preencher com quantidade
      Quando o código do insumo for VERBA - Preencher com quantidade
    */
    if (
      (codeSubstring >= 3000 && codeSubstring <= 3999) ||
      codeSubstring === "VERBA"
    ) {
      sheetMO = quantity;
    } else if (codeSubstring >= 9000 && codeSubstring <= 9999) {
      sheetMO = quantity;
    } else {
      sheetMO = "";
    }

    /*
    Colunas M.O.2 
      Quando o código do insumo começar com 1000~1999 - Vazia
      Quando o código do insumo começar com 3000~3999 - Preencher com o custo unitário
      Quando o código do insumo começar com 9000~9999 - Preencher com o custo unitário
      Quando o código do insumo for com VERBA - Preencher com o custo unitário
    */
    if (
      (codeSubstring >= 3000 && codeSubstring <= 3999) ||
      codeSubstring === "VERBA"
    ) {
      sheetMO2 = cost;
    } else if (codeSubstring >= 9000 && codeSubstring <= 9999) {
      sheetMO2 = cost;
    } else {
      sheetMO2 = "";
    }

    return { sheetMat, sheetMO, sheetMO2 };
  }

  arraysEqual(a, b): boolean {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  updateBudgetResources = () => {
    // Fecha o menu do header
    this.setState({ anchorEl: null });
    WBSStore.updateComposition = true;
  };

  updateCompositions = () => {
    this.setState({ anchorEl: null });
    WBSStore.replaceComposition = true;
  };

  /**
   * Função executada ao clicar para isolar os elementos orçados no visualizador 3D
   * @method handleIsolate
   * @category Viewer3D
   * @param {boolean} reverse - Usado para ver o sentido do isolar, se vai isolar os itens selecionados ou os não selecionados
   * @return {void}
   */
  handleIsolate = async (reverse: boolean = false) => {
    // Fecha o menu do header
    this.setState({ anchorEl: null });
    // Reseta o array da store com a lista de elementos selecionados para isolar
    Render3dStore.setIsolateArray([]);
    Render3dStore.isReverseIsolate = reverse;

    let modelMapRows = WBSStore.dataTable.filter((o) => {
      return (
        o.data.fromModelMap &&
        o.data.fromModelMap !== "" &&
        o.data.rowType === ERowType.STAGE
      );
    });

    // Filtra apenas os IDs das linhas filtradas
    let modelMapIds = modelMapRows.map(function (row) {
      return row.data.fromModelMap;
    });

    // Recupera os model maps utilizados no orçamento
    let ModelMaps = ModelMapStore.modelMaps.filter(
      (i) => modelMapIds.indexOf(i.id) >= 0
    );

    // Recupera as linhas do orçamento com vínculo com model map apenas no quantitativo
    let modelMapQttRows = WBSStore.dataTable.filter(
      (o) => o.data.fromModelMap !== "" && o.data.takeOffQuantity
    );

    // Cria lista com objetos a partir das linhas filtradas
    let modelMapQttIds = modelMapQttRows.map(function (row) {
      return {
        modelMap: row.data.fromModelMap,
        takeOffQuantity: row.data.takeOffQuantity,
      };
    });

    // Efetua filtro na lista de objetos para remover entradas duplicadas
    modelMapQttIds = modelMapQttIds.filter(
      (mm, index, self) =>
        self.findIndex(
          (t) =>
            t.modelMap === mm.modelMap &&
            this.arraysEqual(t.takeOffQuantity, mm.takeOffQuantity)
        ) === index
    );

    // Cria um array auxiliar para receber as labels dos elementos dos model maps
    let isolateArray = new Array<IsolateArray>();

    let recoveredTakeOffs = new Array();
    let promises: Array<Promise<any>> = [];
    for (const mmQtt of modelMapQttIds) {
      promises.push(
        this.extractIfcLabelsFromModelMap(
          recoveredTakeOffs,
          mmQtt,
          isolateArray
        )
      );
    }

    await Promise.all(promises);

    if (ModelMaps) {
      for (const modelMap of ModelMaps) {
        // Percorre as chaves do campo takeOffFormat.GUID, que identificam o id dos modelos 3D
        for (const labelKey of Object.keys(modelMap.data.GUID)) {
          // Percorre a lista de ifcLabels de cada modelo identificado no campo takeOffFormat.GUID
          for (const GUID of modelMap.data.GUID[labelKey]) {
            // Chama função responsável por adicionar os elementos no array para isolar
            this.addElementToIsolateArray(isolateArray, {
              modelId: labelKey,
              GUID,
            });
          }
        }
      }
    }

    // Após concatenar todas as GUID dos elementos de todos os model maps do orçamento, atualiza a variável em store
    if (ModelMaps || modelMapQttIds.length > 0)
      Render3dStore.setIsolateArray(isolateArray);

    // Atualização dos processos para isolar elementos considerando o array tipado com as GUID dos model maps
    if (Render3dStore.xeokitViewer == null) {
      WBSStore.get3dModel(WBSStore.WBS.id);
      WBSStore.handle3DTabXeokit();
      Render3dStore.needIsolateArray = true;
    } else {
      Render3dStore.isolateElements(Render3dStore.isolateArray);
    }
    WBSStore.openViewer3D();
  };

  /**
   * Recupe a lista de elementos dos modelos 3D que devem ser isoladas
   * @param recoveredTakeOffs Flag para identificar informações já recuperadas de formatação de take off em chamadas anteriores
   * @param mmQtt Objeto com propriedades para identificar a chave do model map e o estrutura dentro da formatação do take off
   * @param isolateArray Coleção de elementos que serão isolados
   */
  private async extractIfcLabelsFromModelMap(
    recoveredTakeOffs: any[],
    mmQtt: { modelMap: any; takeOffQuantity: any },
    isolateArray: IsolateArray[]
  ) {
    // Para recuperar os elementos é necessário efetuar o fetch da formatação do model map
    if (recoveredTakeOffs.indexOf(mmQtt.modelMap) < 0) {
      await TakeOffStore.fetchTakeOffFormatedList(undefined, mmQtt.modelMap);
      recoveredTakeOffs.push(mmQtt.modelMap);
    }

    // Recupera as informações de formatação de acordo com os fetchs realizados
    let indexSelected = TakeOffStore.takeOffFormatedList.findIndex(
      (i) => i.id == mmQtt.modelMap
    );
    let takeOffFormatedList = TakeOffStore.takeOffFormatedList[indexSelected]
      ? [...TakeOffStore.takeOffFormatedList[indexSelected].data]
      : new Array();

    // Concatena a estrutura de etapas e a descrição do item da formatação que foram adicionados no orçamento
    const element = mmQtt.takeOffQuantity.join("|");

    // Percorre a formatação do model map
    for (const takeOffFormat of takeOffFormatedList) {
      // Variável para armazenar o caminho da descrição da formatação até a etapa principal onde se encontra
      let qttOrigin = new Array();
      qttOrigin.push(takeOffFormat.description);
      let parentIndex = takeOffFormat.parentListIndex;
      // Loop para percorrer a estrutura da formatação enquanto houver etapas acima da linha sendo verificada
      while (parentIndex >= 0) {
        let parentTkoItem = takeOffFormatedList[parentIndex];
        qttOrigin.push(parentTkoItem.description);
        parentIndex = parentTkoItem.parentListIndex;
      }
      // Concatena a descrição + as etapas da formatação para comparar com a linha do orçamento
      let qttOriginJoin = qttOrigin.join("|");

      // Só atualiza quando não for stage e a descrição for igual a adicionada
      if (qttOriginJoin === element) {
        let dev = DevelopmentStore.developmentSelected;
        // Recupera as labels dos elementos dos modelos armazenada na formatação do model map
        let takeOffGUID = takeOffFormat.GUID;
        for (const labelKey of Object.keys(takeOffGUID)) {
          for (const GUID of takeOffGUID[labelKey]) {
            this.addElementToIsolateArray(isolateArray, {
              modelId: labelKey,
              GUID,
            });
          }
        }
      }
    }
  }

  /**
   * Função responsável por adicionar elementos no array para isolar no visualizador 3D
   * @param isolateArray Array de elementos para isolar
   * @param element Elemento para adicionar ao array
   */
  private addElementToIsolateArray(isolateArray: IsolateArray[], element: any) {
    let idx = isolateArray.findIndex((i) => i.modelId == element.modelId);
    if (idx == -1) {
      isolateArray.push({
        modelId: element.modelId,
        GUID: [element.GUID],
      });
    } else {
      if (element.GUID) {
        isolateArray[idx].GUID.push(element.GUID);
      } else {
        isolateArray[idx].GUID.push(element);
      }
    }
  }

  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;
    const SelectedLine = WBSStore.selectedLine.index === -1;
    const openMenu = Boolean(this.state.anchorEl);
    let moreOption = (
      <MoreHoriz
        className={SelectedLine ? classes.more : classes.moreUnselected}
        onClick={!WBSStore.task ? this.handleClickOptCard : undefined}
      />
    );

    let exportOption = (
      <Menu
        id="long-menu"
        anchorEl={this.state.anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={openMenu}
        onClose={this.handleCloseOptCard}
        PaperProps={{
          style: {
            width: "auto",
            right: "260px",
          },
        }}
        className={classes.cardMenu}
        style={{ top: 56 }}
      >
        {WBSStore.tab === 0 && WBSStore.display3D != "visible" ? (
          <>
            <div className={classes.dividerFirst}>{i18n.export}</div>
            <MenuItem
              key={1}
              selected={false}
              className={classes.menu}
              onClick={async (e) => {
                this.handleCloseOptCard(e);
                TakeOffStore.statusModelmap = "Loading";
                await exportSyntheticEAPReport();
                TakeOffStore.statusModelmap = "Finished";
              }}
              style={{ fontSize: 14 }}
            >
              {i18n.wbs.exportSyntheticxlsx}
            </MenuItem>
            <MenuItem
              key={2}
              selected={false}
              className={classes.menu}
              onClick={async (e) => {
                this.handleCloseOptCard(e);
                TakeOffStore.statusModelmap = "Loading";
                await exportAnalyticalEAPReport();
                TakeOffStore.statusModelmap = "Finished";
              }}
              style={{ fontSize: 14 }}
            >
              {i18n.wbs.exportAnalyticalxlsx}
            </MenuItem>
            <MenuItem
              key={2}
              selected={false}
              className={classes.menu}
              onClick={async (e) => {
                this.handleCloseOptCard(e);
                TakeOffStore.statusModelmap = "Loading";
                await exportSyntheticCurveABCReport();
                TakeOffStore.statusModelmap = "Finished";
              }}
              style={{ fontSize: 14 }}
            >
              {i18n.wbs.exportCurveABC}
            </MenuItem>
            <MenuItem
              key={3}
              selected={false}
              className={classes.menu}
              onClick={async (e) => {
                this.handleCloseOptCard(e);
                TakeOffStore.statusModelmap = "Loading";
                await exportAnalyticalCurveABCReport();
                TakeOffStore.statusModelmap = "Finished";
              }}
              style={{ fontSize: 14 }}
            >
              {i18n.wbs.exportCurveABCAnalytical}
            </MenuItem>
            {CustomPropertyStore.hasDiagramAndTask() && (
              <>
                <MenuItem
                  key={3}
                  selected={false}
                  className={classes.menu}
                  style={{ fontSize: 14 }}
                  onClick={async (event) => {
                    await this.exportSAPSheet(this.props.development);
                    const el = document.getElementById("lnkDownloadCsv");
                    if (el) {
                      el.click();
                      this.setState({ anchorEl: false });
                    }
                  }}
                >
                  {i18n.wbs.exportSAPSheet}
                </MenuItem>
                <CSVLink
                  separator={";"}
                  id="lnkDownloadCsv"
                  data={this.state.csvData}
                  filename={`${this.props.developmentName}.csv`}
                />
              </>
            )}
          </>
        ) : WBSStore.tab !== 0 && WBSStore.display3D != "visible" ? (
          <>
            <div className={classes.divider}>{i18n.export}</div>
            <MenuItem
              key={3}
              selected={false}
              className={classes.menu}
              onClick={() => exportResourceReport()}
              style={{ fontSize: 14 }}
            >
              {i18n.wbs.exportResourcexlsx}
            </MenuItem>
            <MenuItem
              key={4}
              selected={false}
              className={classes.menu}
              onClick={async (e) => {
                this.handleCloseOptCard(e);
                WBSStore.ExportByGroupModal = true;
              }}
              style={{ fontSize: 14 }}
            >
              {i18n.wbs.exportByGroupxlsx}
            </MenuItem>
            {/* <ExcelFile
              element={<div id='excel_id'></div>}
              filename={DevelopmentStore.developmentSelected.data.name + ' - insumos'}
            >
              <ExcelSheet dataSet={this.state.multiDataSet} name='Orçamento' />
            </ExcelFile> */}
          </>
        ) : (
          <></>
        )}

        <div className={classes.divider}>
          {i18n.project.leftSideMenu.viewer}
        </div>
        <MenuItem
          key={5}
          className={classes.menu}
          onClick={() => this.handleIsolate()}
        >
          {i18n.wbs.isolateInCP}
        </MenuItem>
        <MenuItem
          key={6}
          className={classes.menu}
          onClick={() => this.handleIsolate(true)}
        >
          {i18n.wbs.isolateNotInCP}
        </MenuItem>

        <div className={classes.divider}>{i18n.other}</div>
        <MenuItem
          key={7}
          className={classes.menu}
          onClick={() => this.updateBudgetResources()}
        >
          {i18n.wbs.updateBudgetResources}
        </MenuItem>
        <MenuItem
          key={8}
          className={classes.menu}
          onClick={() => this.updateCompositions()}
        >
          {i18n.wbs.updateCompositions}
        </MenuItem>
      </Menu>
    );

    return (
      <div>
        {WBSStore.currentTab == EWBSView.EAP ? (
          <div
            className={SelectedLine ? classes.topBar : classes.topBarUnselected}
            onClick={() => {
              WBSStore.resetSelectedLine(true);
            }}
          >
            <MonetizationOn
              className={
                SelectedLine
                  ? classes.monetization
                  : classes.monetizationUnselected
              }
            />
            <Typography
              className={
                SelectedLine ? classes.topBarText : classes.topBarTextUnselected
              }
              component="span"
            >
              {this.props.name}
            </Typography>
            {moreOption}
            {!WBSStore.task ? exportOption : undefined}
          </div>
        ) : (
          <div className={classes.topBarUnselected}>
            <Cube className={classes.cube} />
            <Typography
              className={classes.topBarTextUnselected}
              component="span"
            >
              {i18n.library.tabTitle3D} - {this.props.name}
            </Typography>
            {moreOption}
            {!WBSStore.task ? exportOption : undefined}
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/modules/costPlan/components/layouts/Header.tsx